import TopNDropdownItem from "../../../table-actions-panel/models/selection-dropdown-item/TopNDropdownItem/TopNDropdownItem";

export default class TopNContactsSelectionItem extends TopNDropdownItem {
    getSelectedTranslation() {
        return {
            key: "si.table-actions-panel.options.contacts.top-n.selected",
            replacements: {
                n: this.formatValue(),
            },
        };
    }
}
